import { useMutation } from "react-query";
import { ActionCreators as NousContacterCreators } from "../../redux/NousContacterRedux";
import Api, { IApi } from "../../services/Api/nonauthentified";
import { Contact } from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";

export const usePostNousContacter = () => {
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<any, any, Contact>(
    // @ts-ignore
    (params: Contact) => api?.postNousContacter(params) || undefined,
    {
      onSuccess: () => {
        NousContacterCreators.postNousContacter.success();
      },
      onError: (error) => {
        NousContacterCreators.postNousContacter.failure(error);
      },
    },
  );
};
